{
  "altitude": {
    "displayName": "Altitudine",
    "unitLabel": {
      "metric": "M",
      "us": "piedi"
    }
  },
  "applicationRateEstimatedMm": {
    "displayName": "Applicazione"
  },
  "applicationRateReportsMm": {
    "displayName": "Applicazione",
    "unitLabel": {
      "metric": "mm",
      "us": "In"
    }
  },
  "calibrationIntercept": {
    "displayName": "Intercettazione di calibrazione"
  },
  "calibrationSlope": {
    "displayName": "Pendenza di calibrazione"
  },
  "configurationId": {
    "displayName": "ID di configurazione"
  },
  "currentPercentage": {
    "displayName": "Percentuale attuale"
  },
  "deviceFunctionCall": {
    "displayName": "Chiamata di funzione del dispositivo"
  },
  "deviceFunctionCallId": {
    "displayName": "causaID"
  },
  "diameterMm": {
    "displayName": "Diametro della ruota",
    "instructions": "Misurare il diametro (distanza massima tra due lati della ruota).",
    "unitLabel": {
      "metric": "mm",
      "us": "In"
    }
  },
  "distanceObservedMm": {
    "displayName": "Distanza",
    "unitLabel": {
      "metric": "M",
      "us": "piedi"
    }
  },
  "flowRateEstimatedLpm": {
    "displayName": "Portata",
    "unitLabel": {
      "metric": "litri/min",
      "us": "galloni/min"
    }
  },
  "gpsType": {
    "displayName": "Modello del chip GPS"
  },
  "heading": {
    "displayName": "Intestazione",
    "unitLabel": "°"
  },
  "hoseWheelMmPerMagnet": {
    "displayName": "Distance Per Magnet",
    "description": "The distance of hose travel for each magnet reading on the hose wheel sensor.",
    "unitLabel": {
      "metric": "mm",
      "us": "in"
    }
  },
  "hoseDiameterMm": {
    "displayName": "Diametro del tubo flessibile",
    "images": {
      "hose_diameter.png": {
        "caption": "Assicuratevi di misurare il tubo nel suo punto più largo."
      }
    },
    "instructions": {
      "1": "Misurare il diametro del tubo flessibile del mulinello con la massima precisione possibile.",
      "2": "Assicuratevi di misurare il tubo nel suo punto più largo. Nell'immagine qui sotto, l'agricoltore usa gli indici per trovare il punto più largo del tubo e usa il metro a nastro per allinearlo."
    },
    "unitLabel": {
      "metric": "mm",
      "us": "pollici"
    }
  },
  "i2cAddress": {
    "displayName": "Indirizzo I2C"
  },
  "installedOrientation": {
    "displayName": "Orientamento installato"
  },
  "internalSoc": {
    "displayName": "Batteria Soc interna",
    "unitLabel": "%"
  },
  "ioPin": {
    "displayName": "Perno di I/O"
  },
  "linearSpeedMmHMax": {
    "displayName": "Velocità massima di ritrazione"
  },
  "linearSpeedMmHMin": {
    "displayName": "Velocità minima di ritrazione"
  },
  "location": {
    "displayName": "Posizione"
  },
  "maxTrackingPercentage": {
    "displayName": "Percentuale massima di tracciamento"
  },
  "milliRpmAvg": {
    "displayName": "giri al minuto",
    "unitLabel": "giri al minuto"
  },
  "milliRpmFast": {
    "displayName": "Soglia di velocità (superiore)",
    "unitLabel": "giri al minuto"
  },
  "milliRpmSlow": {
    "displayName": "Soglia di velocità (inferiore)",
    "unitLabel": "giri al minuto"
  },
  "minTrackingPercentage": {
    "displayName": "Percentuale minima di tracciamento"
  },
  "mlPerPulse": {
    "displayName": "Volume per impulso",
    "unitLabel": {
      "metric": {
        "long": "Litri",
        "short": "L"
      },
      "us": "ragazza"
    }
  },
  "nMagnets": {
    "description": "Quanti magneti sono installati sulla bobina? Per i mulinelli, questo dovrebbe essere compreso tra 8 e 16",
    "displayName": "Numero di magneti installati",
    "images": {
      "magnet_installation_positions.png": {
        "caption": "Installazione standard a 16 magneti"
      }
    },
    "optionLabel": "Magneti"
  },
  "nNozzles": {
    "description": "Quanti ugelli utilizza il mulinello per erogare l'acqua?",
    "displayName": "Numero di ugelli",
    "images": {
      "irrigation_boom.png": {
        "caption": "Un braccio con 12 ugelli."
      },
      "irrigation_gun.png": {
        "caption": "Un mulinello per fucile con un solo ugello."
      }
    }
  },
  "nSats": {
    "displayName": "Qualità del segnale"
  },
  "nWrapsOuterLayer": {
    "description": "Quando il tubo è completamente avvolto attorno alla bobina, quanti giri sono visibili sullo strato più esterno?",
    "displayName": "Numero di avvolgimenti dello strato esterno",
    "images": {
      "reel_outer_hose_wraps.png": {
        "caption": "Un mulinello con 9 avvolgimenti dello strato esterno.\n\nNota che solo gli avvolgimenti del tubo a sinistra e a destra del 9° avvolgimento non vengono conteggiati, anche se sono visibili perché non si trovano sullo strato esterno."
      }
    }
  },
  "flowRateOverrideLpm": {
    "displayName": "Portata forzata",
    "description": "Quando impostato, questo flusso misurato è usato direttamente per i calcoli della cronologia di irrigazione invece di essere stimato dal diametro dell'ugello e dalla pressione.",
    "instructionsWithUnitLabel": "Inserire la portata misurata in {{unitLabel}}, o lasciare vuoto per usare la stima basata sul diametro dell'ugello.",
    "unitLabel": {
      "metric": {
        "long": "litri al minuto",
        "short": "L/min"
      },
      "us": {
        "long": "galloni al minuto",
        "short": "gal/min"
      }
    }
  },
  "nozzleDiameterMm": {
    "displayName": "Diametro ugello",
    "images": {
      "nozzle_diameter.png": {
        "altText": "Foto annotata che illustra la traiettoria di misurazione del diametro dell'ugello.",
        "caption": "Assicuratevi di misurare l'apertura dell'ugello nel suo punto più largo."
      }
    },
    "instructionsWithUnitLabel": "Misurare la larghezza interna dell'ugello in {{unitLabel}}",
    "note": "Assicuratevi di misurare l'apertura dell'ugello nel suo punto più largo.",
    "unitLabel": {
      "metric": {
        "long": "millimetri",
        "short": "mm"
      },
      "us": {
        "long": "pollici",
        "short": "In"
      }
    }
  },
  "otaEnabled": {
    "displayName": "Abilitato O.T.A."
  },
  "outerHoseWrapRadiusMm": {
    "description": "Il raggio di avvolgimento esterno del tubo flessibile è la distanza tra il centro della bobina e il bordo esterno del tubo flessibile quando è completamente avvolto.",
    "displayName": "Raggio di avvolgimento del tubo flessibile esterno",
    "images": {
      "reel_outer_hose_wraps.png": {
        "altText": "Diagramma di misurazione del raggio di avvolgimento del tubo flessibile esterno."
      }
    },
    "instructions": {
      "introduction": "Per determinare questa misurazione, procedere in uno dei seguenti modi:",
      "options": {
        "1": "Se riesci a determinare facilmente dove cadrebbe il bordo esterno del tubo sul lato rivolto verso l'esterno della bobina (vedi immagine sotto), misura la distanza tra il centro dell'asse della bobina e la posizione relativa del bordo del tubo.",
        "2": "In alternativa, puoi guardare all'interno della bobina e misurare la distanza dal bordo esterno della bobina all'inizio del tubo. Sottrai questa distanza dalla distanza tra il bordo della bobina e l'asse della bobina."
      }
    },
    "unitLabel": {
      "metric": "mm",
      "us": "In"
    }
  },
  "pidDerivativeCoeff": {
    "displayName": "Coefficiente derivato PID"
  },
  "pidGainCoeff": {
    "displayName": "Coefficiente di guadagno PID"
  },
  "pidIntegralCoeff": {
    "displayName": "Coefficiente integrale PID"
  },
  "pidSensorSetpoint": {
    "displayName": "Punto di riferimento del sensore PID"
  },
  "pivotRadiusMeters": {
    "displayName": "Raggio del perno",
    "unitLabel": {
      "metric": "Metri",
      "us": "Piedi"
    }
  },
  "pressureObservedKpa": {
    "displayName": "Pressione",
    "unitLabel": {
      "metric": "kPa",
      "us": "psi"
    }
  },
  "pressureReportsKpa": {
    "displayName": "Pressione",
    "unitLabel": {
      "metric": "kPa",
      "us": "psi"
    }
  },
  "rampSecondsRemaining": {
    "displayName": "Secondi rimanenti"
  },
  "rampSecondsTotal": {
    "displayName": "Secondi totali"
  },
  "rateLpmAvg": {
    "displayName": "Portata media",
    "unitLabel": {
      "metric": "litri/min",
      "us": "galloni/min"
    }
  },
  "rateLpmMax": {
    "displayName": "Portata massima",
    "unitLabel": {
      "metric": "litri/min",
      "us": "galloni/min"
    }
  },
  "rateLpmMin": {
    "displayName": "Portata minima",
    "unitLabel": {
      "metric": "litri/min",
      "us": "galloni/min"
    }
  },
  "readingCelsius": {
    "displayName": "Temperatura",
    "unitLabel": {
      "metric": "C°",
      "us": "E°"
    }
  },
  "readingKpa": {
    "displayName": "Pressione",
    "unitLabel": {
      "metric": "kPa",
      "us": "psi"
    }
  },
  "reportingPeriodEndDt": {
    "displayName": "Fine del periodo di rendicontazione"
  },
  "reportingPeriodStartDt": {
    "displayName": "Inizio del periodo di rendicontazione"
  },
  "relativePercentage": {
    "displayName": "Percentuale relativa (%)",
    "unitLabel": {
      "metric": "%",
      "us": "%"
    }
  },
  "runDistanceMmCurrent": {
    "displayName": "Distanza rimanente",
    "unitLabel": {
      "metric": "M",
      "us": "piedi"
    }
  },
  "runDistanceMmElapsed": {
    "displayName": "Distanza trascorsa",
    "unitLabel": {
      "metric": "M",
      "us": "piedi"
    }
  },
  "runDistanceMmMax": {
    "displayName": "Distanza estesa",
    "unitLabel": {
      "metric": "M",
      "us": "piedi"
    }
  },
  "runMagnetCountCurrent": {
    "displayName": "Conteggio corrente magnete"
  },
  "runMagnetCountMax": {
    "displayName": "Numero massimo di magneti"
  },
  "runSpeedMmpm": {
    "displayName": "Velocità di corsa",
    "unitLabel": {
      "metric": "m/ora",
      "us": "piedi/ora"
    }
  },
  "scheduledDeviceAction": {
    "displayName": "Azione programmata del dispositivo"
  },
  "sensorModelId": {
    "displayName": "Modello del sensore"
  },
  "sensorPort": {
    "description": "I sensori di bobina, pressione, ruota e flusso possono essere installati ciascuno su una delle porte sensore di un dispositivo FarmHQ (solo generazioni FC2 e TC3).",
    "displayName": "Porta sensore",
    "displayNameWithVal": "Porta {{val}}",
    "fieldLabelWithSensorName": "Porta sensore {{sensorName}}",
    "images": {
      "enclosure_front.png": {
        "caption": "Porte sensore 1 (al centro a sinistra) e 2 (al centro a destra) su un contenitore FarmHQ FC2."
      }
    },
    "values": {
      "port-1": "Porta 1",
      "port-2": "Porta 2"
    }
  },
  "sensorPriority": {
    "displayName": "Priorità del sensore"
  },
  "sensorTriggeredUpdate": {
    "displayName": "Aggiornamento attivato dal sensore"
  },
  "signalQuality": {
    "displayName": "Qualità del segnale"
  },
  "signalStrength": {
    "displayName": "Potenza del segnale"
  },
  "speedMillirpm": {
    "displayName": "Velocità di rotazione",
    "unitLabel": "giri al minuto"
  },
  "speedMmpm": {
    "displayName": "Velocità",
    "unitLabel": {
      "metric": "m/ora",
      "us": "piedi/ora"
    }
  },
  "speedObservedMmpm": {
    "displayName": "Velocità",
    "unitLabel": {
      "metric": "m/ora",
      "us": "piedi/ora"
    }
  },
  "speedReportsMmpm": {
    "displayName": "Velocità",
    "unitLabel": {
      "metric": "m/ora",
      "us": "piedi/ora"
    }
  },
  "speedMeasurementMethod": {
    "displayName": "Speed Measurement Method",
    "description": "Choose how reel speed is measured. 'Spool Rotation' calculates speed from spool geometry. 'Hose Wheel' measures the hose directly as it passes a sensor wheel.",
    "values": {
      "spool_rotation": "Spool Rotation",
      "hose_wheel": "Hose Wheel"
    }
  },
  "applicationType": {
    "displayName": "Tipo di applicazione",
    "description": "Ciò che questo rotolone applica al campo. Ogni passaggio del rotolone viene annotato con questo tipo. Il valore predefinito è acqua.",
    "values": {
      "water": "Acqua",
      "manure": "Liquame",
      "other": "Altro"
    }
  },
  "sprinklerType": {
    "description": "Selezionando \"Gun\" verranno aggiunte estremità semicircolari alle strisce nella mappa dello stato del dispositivo e nella pagina Cronologia irrigazione campo.",
    "displayName": "Tipo di irrigatore",
    "values": {
      "boom": "Boom",
      "gun": "Pistola"
    }
  },
  "startRampPercentage": {
    "displayName": "Percentuale di partenza"
  },
  "stateCurrent": {
    "displayName": "Stato attuale"
  },
  "stateCurrentInitDt": {
    "displayName": "Ultimo cambio di stato"
  },
  "statePrevious": {
    "displayName": "Stato precedente"
  },
  "statePreviousInitDt": {
    "displayName": "Cambiamento di stato precedente"
  },
  "stoppedTimeoutMs": {
    "displayName": "Timeout ruota ferma",
    "description": "Per quanto tempo il dispositivo attende senza rilevare il movimento della ruota prima di segnalare la ruota come ferma.",
    "unitLabel": "min"
  },
  "swathWidthMm": {
    "descriptionWithUnitLabel": "Una stima della larghezza di una riga in {{unitLabel}}. Per i mulinelli, questo raddoppia anche la distanza a cui l'acqua viene spruzzata dalla pistola.",
    "displayName": "Larghezza della striscia",
    "placeholder": "Inserisci la larghezza della striscia",
    "unitLabel": {
      "metric": "M",
      "us": "piedi"
    }
  },
  "switchType": {
    "helpBodyText": "L'impostazione predefinita dell'interruttore indica se l'interruttore è normalmente aperto o normalmente chiuso.\n\nIn caso di dubbi, contattare l'assistenza FarmHQ.",
    "displayName": "Impostazione predefinita dell'interruttore",
    "values": {
      "C": "Chiuso",
      "O": "aprire"
    }
  },
  "targetRampPercentage": {
    "displayName": "Percentuale di destinazione"
  },
  "threshold": {
    "displayName": "Soglia",
    "unitLabel": {
      "metric": "kPa",
      "us": "psi"
    }
  },
  "thresholdPsiLower": {
    "descriptionWithValue": "Qualsiasi valore inferiore a {{value}} è troppo basso.",
    "displayName": "Soglia inferiore",
    "unitLabel": {
      "metric": "kPa",
      "us": "psi"
    }
  },
  "thresholdPsiUpper": {
    "descriptionWithValue": "Qualsiasi valore superiore a {{value}} è troppo alto.",
    "displayName": "Soglia superiore",
    "unitLabel": {
      "metric": "kPa",
      "us": "psi"
    }
  },
  "voltageChangeMvPerHour": {
    "displayName": "Variazione di tensione"
  },
  "voltageIntercept": {
    "displayName": "Intercettazione della tensione"
  },
  "voltageMv": {
    "displayName": "Voltaggio",
    "unitLabel": "E"
  },
  "voltageSlope": {
    "displayName": "Pendenza della tensione"
  },
  "voltageThresholdLowMv": {
    "displayName": "Soglia di tensione inferiore",
    "unitLabel": "Volt"
  },
  "volumeLFinal": {
    "displayName": "Volume Final",
    "unitLabel": {
      "metric": "l",
      "us": "ragazza"
    }
  },
  "volumeLInitial": {
    "displayName": "Volume iniziale",
    "unitLabel": {
      "metric": "l",
      "us": "ragazza"
    }
  },
  "volumeLTotal": {
    "displayName": "Volume totale",
    "unitLabel": {
      "metric": "l",
      "us": "ragazza"
    }
  },
  "widthMm": {
    "displayName": "Larghezza della bobina",
    "images": {
      "reel_width.png": {
        "caption": "Diagramma della larghezza della bobina."
      }
    },
    "instructions": "Misurare la distanza tra le pareti della bobina.",
    "unitLabel": {
      "metric": "mm",
      "us": "In"
    }
  }
}
